import React, { Component } from 'react';


import { Link } from "react-router-dom";

import './../scss/LoadMoreVideoCard.scss';
import { getRelativeUrl } from '../../util/lib';
import PropTypes from 'prop-types';
import LoadMore from '../svg/LoadMore/LoadMore';
import { shapeFixer, RATIO_16x9 } from '../../util/imageUtils';

class LoadMoreVideoCard extends Component {

	static propTypes = {
		float: PropTypes.string,
		size: PropTypes.string,
		card: PropTypes.shape({
			data: PropTypes.shape({
				video_name: PropTypes.string,
				video_thumbnails: PropTypes.object,
				url: PropTypes.shape({
					path: PropTypes.string,
				}),
			}),
		})
	}
	static defaultProps = {
		float: '',
		size: 'col-3'
	}
	render() {
		const props = this.props,
			card = props.card,
			float = props.float,
			size = props.size,
			data = card.data,
			url = data.url.path || getRelativeUrl(data.url.url);

		return (
			<div className={"v-card video-card load-more " + size + " " + float}>
				<Link to={url} title="Load More">
					<img src={shapeFixer(RATIO_16x9)}/>
					<div className="more-icon"><LoadMore /></div>
				</Link>
			</div>
		);
	}
}

export default LoadMoreVideoCard;